import { render, staticRenderFns } from "./PotensiDesa.vue?vue&type=template&id=d10ee1ec&scoped=true"
import script from "./PotensiDesa.vue?vue&type=script&lang=js"
export * from "./PotensiDesa.vue?vue&type=script&lang=js"
import style0 from "./PotensiDesa.vue?vue&type=style&index=0&id=d10ee1ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10ee1ec",
  null
  
)

export default component.exports